import { render } from "./GlobalPerson.vue?vue&type=template&id=7ba85e14"
import script from "./GlobalPerson.vue?vue&type=script&lang=js"
export * from "./GlobalPerson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__